<template>
	<div class="omapi-monsterleads__actions tablenav">
		<div class="omapi-monsterleads__actions-left">
			<monsterleads-contacts-bulk-actions :is-bulk="bulk.length > 0" />
			<span v-if="slug" class="omapi-monsterleads__actions-link">
				<core-button class="omapi-monsterleads__edit" :is-link="true" :link-style="true" :href="builderLink">
					<i class="fa fa-pencil" aria-hidden="true"></i>Edit Campaign
				</core-button>
			</span>
			<span v-if="leads.length > 0" class="omapi-monsterleads__actions-link">
				<core-button :link-style="true" class="omapi-app-exit" @click="downloadExport">Export</core-button>
			</span>
			<span v-if="leads.length > 0" class="omapi-monsterleads__actions-link">
				<core-button :link-style="true" @click="$modal.show('email-upsell')"
					><i class="fa fa-envelope-o" aria-hidden="true"></i>Send a Bulk Email</core-button
				>
			</span>
		</div>
		<div class="omapi-monsterleads__actions-right">
			<monsterleads-table-pagination :page-total="leads.length" />
		</div>
	</div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
const { mapState, mapGetters } = createNamespacedHelpers('monsterleads');

export default {
	computed: {
		...mapState(['export', 'leads', 'bulk']),
		...mapGetters(['selectedCampaign']),
		slug() {
			return this.$get('selectedCampaign.slug');
		},
		settingEnabled() {
			return this.$get('selectedCampaign.enabled', false);
		},
		/**
		 * Get the path to edit this campaign.
		 *
		 * @returns {string} The URI
		 */
		builderLink() {
			return this.$urls.builderLink(this.slug, this.settingEnabled);
		},
	},
	methods: {
		downloadExport() {
			this.$modal.show('lead-export-modal');
		},
	},
};
</script>

<style lang="scss">
@import '../../../assets/scss/variables';
.omapi-screen .omapi-monsterleads__actions {
	display: flex;
	justify-content: space-between;
	margin: 11px 0 16px;
	align-items: center;
	&-left {
		display: flex;
	}
	&-link {
		margin-right: 16px;
		color: $color_blue-primary;
		display: flex;
		align-items: center;
		i.fa {
			margin-right: 7px;
		}
		.omapi-app-exit {
			display: flex;
			align-items: center;
		}
	}
	&-right {
		.omapi-pagination {
			margin: 0;
		}
	}
}
</style>
